import React from "react"
import { render } from "react-dom"
import { ConnectedRouter } from "react-router-redux"
import { ApolloProvider } from "react-apollo"
import { Provider } from "react-redux"
import { ThemeProvider } from "styled-components"
import { addLocaleData } from "react-intl"
import client from "./apollo"
import createStore from "./store"
import history from "./history"

import "sanitize.css/sanitize.css"
import "antd/dist/antd.css"
import "./utils/overwrite-ant-styles"
import en from "react-intl/locale-data/en"
import fr from "react-intl/locale-data/fr"

import "./index.css"
import App from "./App"
import registerServiceWorker from "./registerServiceWorker"
import { MainTheme } from "./lib/theme"

export const { store, persistor } = createStore()

const target = document.querySelector("#root")

addLocaleData([...en, ...fr])

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ApolloProvider client={client}>
        <ThemeProvider theme={MainTheme}>
          <App />
        </ThemeProvider>
      </ApolloProvider>
    </ConnectedRouter>
  </Provider>,
  target
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js